import React from 'react';
import { observer } from 'mobx-react';
import { 
  EntitiesList,
  EntitiesListHeader,
  EntitiesListContent,
  EntityListItem,
  EntityIcon,
  EntityInfo,
  EntityName,
  EntityDescription,
  AddEntityRowWrapper,
  AddEntityRowIconWrapper,
  AddEntityRowTextWrapper
} from './EntitiesListPanel.styles';
import { HoldingEntitySvg } from '../EntityIcons';
import { ChevronIcon, DefaultEntityIcon, EmptyStatePlusIcon } from '../../assets/icons';
import { useStore } from '../../../app/data/root.store';
import { ActionLocked } from '../../../../common/components/ActionLocked/ActionLocked';
import { ActionLockedIconWithTooltip } from '../../../../common/components/ActionLocked/ActionLockedIconWithTooltip';
import { HoldingEntityRowCollapsibleDefaultBadge } from '../../../user/components/HoldingEntityList/HoldingEntityRow.styles';
import { ModifiedTooltip } from '../../../../common/components/ModifiedTooltip/ModifiedTooltip';
import { MobileBackButton } from '../../../../assets/icons/common/common-icons';
import { MobileBackButtonWrapper } from '../../../layout/components/MobileLayout.styles';

export const EntitiesListPanel = observer(({
  entities = [],
  selectedEntity,
  selectedEntityId,
  onEntitySelect,
  onAddEntity,
  onClose
}) => {
  const { userStore, uiStore, entitiesStore } = useStore();
  return (
    <EntitiesList>
      <EntitiesListHeader>
        {!uiStore.isDesktopView && (
          <MobileBackButtonWrapper
            onClick={onClose}
            fontColor={'#000'}
          >
            <MobileBackButton />
          </MobileBackButtonWrapper>
        )}
        Holding entity list
      </EntitiesListHeader>

      <EntitiesListContent>
        {entities.map((entity) => {
          const isSelected = selectedEntityId ? 
            selectedEntityId + '' === entity.id + '' : 
            selectedEntity?.id === entity.id;
          
          const itemCount = entity.items?.length || 0;

          const handleMouseEnter = () => {
            entitiesStore.setHoveredEntityId(entity.id + '');
          };

          const handleMouseLeave = () => {
            entitiesStore.setHoveredEntityId(null);
          };

          return (
            <EntityListItem
              key={entity.id}
              isSelected={isSelected}
              isHovered={entitiesStore.isEntityHovered(entity.id)}
              onClick={() => onEntitySelect(entity.id + '')}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <EntityIcon color={entity.color_code || entity.colorCode}>
                <HoldingEntitySvg width={20} height={20} color="#1A1B1D" />
              </EntityIcon>
              
              <EntityInfo>
                <EntityName title={entity.name}>
                  {entity.name}
                </EntityName>
                <EntityDescription>
                  {itemCount} items
                </EntityDescription>
              </EntityInfo>
              {entity.isDefault && <HoldingEntityRowCollapsibleDefaultBadge><ModifiedTooltip title={'This is the default holding entity when an item is created'} placement="top">
            <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>Default <DefaultEntityIcon /></div>
          </ModifiedTooltip>
          </HoldingEntityRowCollapsibleDefaultBadge>}
              
              <ChevronIcon />
            </EntityListItem>
          );
        })}
        
        <ActionLocked action={'addHoldingEntity'} blockCb={() => {}}>
          <AddEntityRowWrapper onClick={onAddEntity}>
            <AddEntityRowIconWrapper>
              <EmptyStatePlusIcon />
            </AddEntityRowIconWrapper>
            <AddEntityRowTextWrapper>
              {uiStore.isDesktopView ? 'Add holding entity' : 'Add new'}
              {userStore.isActionBlockedByRole('addHoldingEntity') && <ActionLockedIconWithTooltip marginLeft={'8px'} iconColor={'#9097A3'} isRoleBlocked={true} />}
            </AddEntityRowTextWrapper>
          </AddEntityRowWrapper>
        </ActionLocked>
      </EntitiesListContent>
    </EntitiesList>
  );
}); 